import React from "react";
import "./gallery.css";

function Gallery() {
    return (
        <div id="gallery-570">
            <picture className="cs-picture">
                <source media="(max-width: 600px)" srcset="/images/rath-yatra-2024.jpeg"></source>
                <source media="(min-width: 601px)" srcset="/images/rath-yatra-2024.jpeg"></source>
                <img loading="lazy" decoding="async" src="/images/rath-yatra-2024.jpeg" alt="Rath Yatra" width="480" height="549"></img>
            </picture>
            <picture className="cs-picture">
                <source media="(max-width: 600px)" srcset="/images/temple-alter-1.jpeg"></source>
                <source media="(min-width: 601px)" srcset="/images/temple-alter-1.jpeg"></source>
                <img loading="lazy" decoding="async" src="/images/temple-alter-1.jpeg" alt="Temple Alter" width="480" height="549"></img>
            </picture>
            <picture className="cs-picture">
                <source media="(max-width: 600px)" srcset="/images/ratyatra-2024-1.jpeg"></source>
                <source media="(min-width: 601px)" srcset="/images/ratyatra-2024-1.jpeg"></source>
                <img loading="lazy" decoding="async" src="/images/ratyatra-2024-1.jpeg" alt="Rath Yatra" width="480" height="549"></img>
            </picture>
            <picture className="cs-picture">
                <source media="(max-width: 600px)" srcset="/images/temple-event.jpeg"></source>
                <source media="(min-width: 601px)" srcset="/images/temple-event.jpeg"></source>
                <img loading="lazy" decoding="async" src="/images/temple-event.jpeg" alt="Temple Event" width="480" height="549"></img>
            </picture>
            <picture className="cs-picture">
                <source media="(max-width: 600px)" srcset="/images/sunflower.jpeg"></source>
                <source media="(min-width: 601px)" srcset="/images/sunflower.jpeg"></source>
                <img loading="lazy" decoding="async" src="/images/sunflower.jpeg" alt="Sunflower" width="480" height="549"></img>
            </picture>
            <picture className="cs-picture">
                <source media="(max-width: 600px)" srcset="/images/radha-madhav.jpeg"></source>
                <source media="(min-width: 601px)" srcset="/images/radha-madhav.jpeg"></source>
                <img loading="lazy" decoding="async" src="/images/radha-madhav.jpeg" alt="Radha Madhav" width="480" height="549"></img>
            </picture>
            <picture className="cs-picture">
                <source media="(max-width: 600px)" srcset="/images/karvachauth-2021.jpeg"></source>
                <source media="(min-width: 601px)" srcset="/images/karvachauth-2021.jpeg"></source>
                <img loading="lazy" decoding="async" src="/images/karvachauth-2021.jpeg" alt="Karvachauth" width="480" height="549"></img>
            </picture>
            <picture className="cs-picture">
                <source media="(max-width: 600px)" srcset="/images/ratyatra-2024-1.jpeg"></source>
                <source media="(min-width: 601px)" srcset="/images/ratyatra-2024-1.jpeg"></source>
                <img loading="lazy" decoding="async" src="/images/ratyatra-2024-1.jpeg" alt="rath yatra" width="480" height="549"></img>
            </picture>
            <picture className="cs-picture">
                <source media="(max-width: 600px)" srcset="/images/temple-alter.jpeg"></source>
                <source media="(min-width: 601px)" srcset="/images/temple-alter.jpeg"></source>
                <img loading="lazy" decoding="async" src="/images/temple-alter.jpeg" alt="Alter temple" width="480" height="549"></img>
            </picture>
            <picture className="cs-picture">
                <source media="(max-width: 600px)" srcset="/images/volleyball-fund-raise-2021.jpeg"></source>
                <source media="(min-width: 601px)" srcset="/images/volleyball-fund-raise-2021.jpeg"></source>
                <img loading="lazy" decoding="async" src="/images/volleyball-fund-raise-2021.jpeg" alt="Karvachaut" width="480" height="549"></img>
            </picture>
        </div>       
    );
}
export default Gallery;